import AppDispatcher from '../dispatcher/AppDispatcher';
import {
  REQUEST_CREATE_M_TRACK_CONSENT,
  REQUEST_CREATE_M_TRACK_CONSENT_ERROR,
  REQUEST_CREATE_M_TRACK_CONSENT_SUCCESS,
  REQUEST_M_TRACK_CONSENT,
  REQUEST_M_TRACK_CONSENT_ERROR,
  REQUEST_M_TRACK_CONSENT_SUCCESS,
  REQUEST_M_TRACK_WHITELIST,
  REQUEST_M_TRACK_WHITELIST_ERROR,
  REQUEST_M_TRACK_WHITELIST_SUCCESS,
} from '../constants/MTrackConstants';

export function getMTrackEnabled() {
  AppDispatcher.handleViewAction({
    actionType: REQUEST_M_TRACK_WHITELIST,
  });
}

export function handleMTrackEnabledSuccess(response) {
  AppDispatcher.handleServerAction({
    actionType: REQUEST_M_TRACK_WHITELIST_SUCCESS,
    data: response,
  });
}

export function handleMTrackEnabledError(error) {
  AppDispatcher.handleServerAction({
    actionType: REQUEST_M_TRACK_WHITELIST_ERROR,
    data: error,
  });
}

export function getMTrackConsented() {
  AppDispatcher.handleViewAction({
    actionType: REQUEST_M_TRACK_CONSENT,
  });
}

export function handleMTrackConsentedSuccess(response) {
  AppDispatcher.handleServerAction({
    actionType: REQUEST_M_TRACK_CONSENT_SUCCESS,
    data: response,
  });
}

export function handleMTrackConsentedError(error) {
  AppDispatcher.handleServerAction({
    actionType: REQUEST_M_TRACK_CONSENT_ERROR,
    data: error,
  });
}

export function createMTrackConsent() {
  AppDispatcher.handleViewAction({
    actionType: REQUEST_CREATE_M_TRACK_CONSENT,
  });
}

export function handleMTrackConsentCreateSuccess(response) {
  AppDispatcher.handleServerAction({
    actionType: REQUEST_CREATE_M_TRACK_CONSENT_SUCCESS,
    data: response,
  });
}

export function handleMTrackConsentCreateError(error) {
  AppDispatcher.handleServerAction({
    actionType: REQUEST_CREATE_M_TRACK_CONSENT_ERROR,
    data: error,
  });
}
